// Consent-gated beacon to the anonymous Conversions API relay.
//
// Fires a server-side copy of a Meta Pixel event (PageView / ViewContent) to
// `POST /analytics/meta_events`, carrying the same `eventID` the browser Pixel
// used so Meta can dedupe the browser and server copies. Unlike the first-party
// `recordPageView` beacon this shares data with Meta, so it is gated on
// marketing consent and only ever sends the two allow-listed event names.

import { readConsent } from './consent'
import { readMetaCookieIds } from './attribution'

/**
 * Post a matching server-side beacon for a browser Pixel event. Self-gated:
 * a no-op unless marketing consent is granted, so callers never re-check.
 * Best-effort — never throws or blocks navigation.
 */
export function postMetaEventPing(eventName: 'PageView' | 'ViewContent', eventId: string): void {
  if (!readConsent().marketing) return
  if (typeof window === 'undefined') return

  const body = JSON.stringify({
    event_name: eventName,
    event_id: eventId,
    event_source_url: window.location.href,
    marketing_consent: true,
    ...readMetaCookieIds(),
  })

  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon('/analytics/meta_events', new Blob([body], { type: 'application/json' }))
      return
    }
    void fetch('/analytics/meta_events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    })
  } catch {
    /* best-effort — never block navigation */
  }
}
